import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_INVITATIONS } from '@/app/module/user/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetInvitations = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)

  const res = esApi.endpoints.getOrgInvitesList.useQuery({
    orgId: orgId.toString(),
  })

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-wa-template': {
          type: 'error',
          message: getErrorMessage(res.error, ERROR_GET_INVITATIONS),
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
